import useDispatch from 'hooks/useDispatch'
import { useSelector } from 'react-redux'
import {
  updateBackgroundColor,
  updateDefaultLabelColor,
  updateSelectedLabelColor,
} from 'slices/Cms/Content/AppNavigation/Style'
import { selectStyleSection } from 'slices/Cms/Content/AppNavigation/Style/selectors'

export const useStyleSection = () => {
  const dispatch = useDispatch()
  const styleSectionState = useSelector(selectStyleSection)

  const actions = {
    updateBackgroundColor: (color: string) =>
      dispatch(updateBackgroundColor(color)),
    updateDefaultLabelColor: (color: string) =>
      dispatch(updateDefaultLabelColor(color)),
    updateSelectedLabelColor: (color: string) =>
      dispatch(updateSelectedLabelColor(color)),
  }

  return {
    state: styleSectionState,
    actions,
  }
}
